import $$ from 'cmn-utils'

const baseUrl = "/api/safety/task/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    positionList: (params) => {
        return $$.get(baseUrl + 'position/list', params)
    },
}